import cache from '@/services/cache-service';
import countriesApi from '@/services/resources/countriesApi';

export function getAll() {
    return cache.get('countries.all', async () => countriesApi.getAll());
}

export default { getAll };
